import { render, staticRenderFns } from "./sendNotification.vue?vue&type=template&id=f89a4e7c&scoped=true"
import script from "./sendNotification.vue?vue&type=script&lang=js"
export * from "./sendNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89a4e7c",
  null
  
)

export default component.exports